import { z } from 'zod';
export const MessageMetadataSchema = z.object({
    createdAt: z.iso.datetime().optional(),
    inputTokens: z.number().optional(),
    outputTokens: z.number().optional(),
    provider: z.string().optional(),
    // Canonical market identity of the model (vendor/model, e.g.
    // qwen/qwen3.5-397b-a17b). `provider` (the host) is kept separate — never
    // concatenated (mirrors the billing journal's two columns).
    model: z.string().optional(),
    reasoningTokens: z.number().optional(),
    cacheReadTokens: z.number().optional(),
    cacheWriteTokens: z.number().optional(),
    stepCount: z.number().optional(),
    durationMs: z.number().optional(),
    finishReason: z.string().optional(),
    // Set when the loop hit the step limit with work still pending. Drives the
    // front's "Continue" button.
    stoppedAtStepLimit: z.boolean().optional(),
    // Set when the turn was cut short mid-loop because the subject ran out of
    // credits. Lets the front surface a recharge prompt.
    stoppedAtCreditLimit: z.boolean().optional(),
    summary: z.string().optional(),
    // Records whether summarization-based compaction was active when this
    // assistant message was generated. Lets the admin console tell apart turns
    // that ran with the compaction pipeline from turns that didn't, and is
    // independent of whether `summary` was eventually filled in (which can
    // also happen retroactively via backfill).
    summarizationActive: z.boolean().optional()
});
export const ConversationUsageSchema = z.object({
    inputTokens: z.number().int().nonnegative(),
    outputTokens: z.number().int().nonnegative(),
    messageCount: z.number().int().nonnegative(),
    // Credits actually debited for this conversation, in the stored sub-unit (like
    // `Balance.consumed` — the app divides by its CREDIT_SUBUNIT to display). Sums
    // the EFFECTIVE debits, so it reflects whatever the app's barème priced (or
    // didn't). Optional: absent when the deployment has no billing wired.
    consumedCredits: z.number().int().nonnegative().optional()
});
